<header [class.halloween]="seasonalTheme.halloween">
    @if(seasonalTheme.halloween) {
        <app-halloween-header-decor></app-halloween-header-decor>
    }
    <div class="header-content">
        <!-- header-left -->
        <div class="header-left">
            <button class="menu-toggle" (click)="toggleMenu()">☰</button>
            <a href="#" [routerLink]="['/home']" class="emp-logo" title="Emporio Elettrico">
                <img [src]="logo()" class="emp-logo d-none d-md-inline-block" alt="Emporio Elettrico">
                <img src="images/loghi/logo-small-nobar.webp" class="emp-logo d-inline-block d-md-none" alt="Emporio Elettrico">
            </a>
        </div>
        <div class="header-middle-left">
            <app-lang></app-lang>
        </div>
        <!--// header-left -->
        <!-- header-middle -->
        <div class="header-middle header-icon header-search header-search-inline header-search-category d-sm-block w-lg-max text-right mt-0">
            @if(!authService.isLoading()) {
                <div appFadeInUp class="header-search-wrapper mr-1">
                    <input #searchInput (input)="search_query.set(searchInput.value)" (keydown.enter)="onSearchSubmit()" type="text" class="search-input" placeholder="{{ 'headertop.cerca' | T }}" attr.aria-label="{{ 'headertop.cerca' | T }}">
                    <button class="btn btn-search p-0" title="{{ 'headertop.cerca' | T }}" type="submit" (click)="onSearchSubmit()">
                        <fa-icon [icon]="faSearch"></fa-icon>
                    </button>
                </div>
            }
        </div>
        <!--// header-middle -->
        <!-- header-right -->
        <div class="header-right">
            @defer (hydrate on idle) {
                <div appFadeInUp class="header-area-wrap">
                    <a routerLink="/wishlist" class="header-icon mr-0 position-relative" title="{{ 'wishlist' | T}}">
                        <fa-icon class="emp-header-icon wish-list-icon" [icon]="faWishList"></fa-icon>
                        @if(wishlist.count() > 0) {
                            <div class="emp-cart-item-number emp-cart-item-number-wish">{{ wishlist.count() }}</div>
                        }
                    </a>
                    <div class="emp-header-two-line d-none d-lg-inline-block">
                        <span class="emp-header-top-line">{{ 'headertop.whislist_latua' | T}}</span>
                        <a routerLink="/wishlist" class="emp-header-bottom-line" title="{{ 'wishlist' | T}}">
                            {{'headertop.whislist' | T}}
                        </a>
                    </div>
                </div>
                <div appFadeInUp class="header-area-wrap">
                    @if(authService.isLoggedSignal() && !authService.isGuestSignal()) {
                        <a routerLink="/userarea/dashboard">
                            <fa-icon class="emp-header-icon user-logged-icon" [icon]="faUserLogged" title="{{ 'dashboard' | T}}"></fa-icon>
                        </a>
                    } @else {
                        <a routerLink="/login">
                            <fa-icon class="emp-header-icon user-guest-icon" [icon]="faUserUnlogged" title="{{ 'headertop.login_reg' | T}}"></fa-icon>
                        </a>
                    }
                    <div class="emp-header-two-line d-none d-lg-inline-block">
                        <span class="emp-header-top-line">{{ 'headertop.benvenuto' | T }}!</span>
                        @if(!authService.isLoggedSignal() || authService.isGuestSignal()) {
                            <a routerLink="/login" class="emp-header-bottom-line" title="{{ 'headertop.login_reg' | T}}">
                                {{ 'headertop.login_reg' | T }}
                            </a>
                        } @else {
                            <a routerLink="/userarea/dashboard" class="emp-header-bottom-line" title="{{ 'dashboard' | T}}">
                                {{ authService.userName() }}
                            </a>
                        }
                    </div>
                </div>
            } @placeholder {
                <div class="header-area-wrap header-auth-placeholder"></div>
                <div class="header-area-wrap header-auth-placeholder"></div>
            }

            <div class="header-area-wrap emp-cart-wrap">
                <button type="button" class="emp-link-button emp-open-cart-btn" (click)="openCart()">
                    <fa-icon class="emp-header-icon cart-icon"
                            [icon]="faCartShopping"
                            [animation]="cartIconAnimation.animation">
                    </fa-icon>
                    @if(cartCookieService.cartValue().nrarticoli > 0) {
                        <div class="emp-cart-item-number">{{ cartCookieService.cartValue().articoli.length }}</div>
                    }
                </button>
                @if(cartCookieService.cartValue().nrarticoli > 0) {
                    <button type="button" class="emp-link-button emp-open-cart-btn" (click)="openCart()">
                        <div class="emp-cart-total">
                            {{ cartTotal() | currency }}
                        </div>
                    </button>
                }
            </div>
        </div>
        <!--// header-right -->
    </div>
</header>